export default __webpack_public_path__ + "static/desk01-fd6ed104a25b0953ca9d57d26767c213.png";